import { supabase } from './supabase'
import { getUsageSessionId } from './usage'

export type OperationalIntelligence = {
  period_days: number
  comparison: {
    current: {
      unique_users: number
      sessions: number
      module_views: number
      searches: number
      no_result_searches: number
      feedback_total: number
      resolution_pct: number
    }
    previous: {
      unique_users: number
      sessions: number
      module_views: number
      searches: number
      no_result_searches: number
      feedback_total: number
      resolution_pct: number
    }
  }
  units: Array<{
    unit_key: string
    unit_label: string
    sessions: number
    unique_users: number
    module_views: number
    searches: number
    no_result_searches: number
    resolution_pct: number
  }>
  top_searches: Array<{ query_text: string; searches: number; avg_results: number; selections: number }>
  no_result_searches: Array<{ query_text: string; searches: number; users: number; last_search: string | null }>
  selected_content: Array<{ selected_key: string; selected_label: string; selections: number; users: number }>
  feedback: Array<{ target_key: string; target_label: string; responses: number; resolved_yes: number; resolution_pct: number }>
  module_usage: Array<{ module_key: string; module_label: string; accesses: number; users: number; last_access: string | null }>
  release_impact: Array<{
    release_id: number
    version: string
    titulo: string
    published_at: string
    days_after: number
    before_daily_avg: number
    after_daily_avg: number
  }>
  anomalies: Array<{
    module_key: string
    module_label: string
    today_accesses: number
    baseline_daily_avg: number
    change_pct: number | null
  }>
}

export async function recordSearchEvent(userId: string, searchId: string, query: string, resultCount: number) {
  if (!navigator.onLine) return
  const sessionId = getUsageSessionId(userId)
  const { error } = await supabase.rpc('record_search_event', {
    p_search_id: searchId,
    p_session_id: sessionId,
    p_query: query,
    p_result_count: resultCount,
  })
  if (error) throw error
}

export async function selectSearchResult(searchId: string, selectedKey: string, selectedLabel: string) {
  if (!navigator.onLine) return
  const { error } = await supabase.rpc('select_search_result', {
    p_search_id: searchId,
    p_selected_key: selectedKey,
    p_selected_label: selectedLabel,
  })
  if (error) throw error
}

export async function saveContentFeedback(userId: string, targetKey: string, targetLabel: string, resolved: boolean) {
  if (!navigator.onLine) return
  const sessionId = getUsageSessionId(userId)
  const { error } = await supabase.rpc('save_content_feedback', {
    p_session_id: sessionId,
    p_target_key: targetKey,
    p_target_label: targetLabel,
    p_resolved: resolved,
  })
  if (error) throw error
}

export async function loadOperationalIntelligence(days: number): Promise<OperationalIntelligence> {
  const { data, error } = await supabase.rpc('operational_intelligence', { p_days: days })
  if (error) throw error
  return data as OperationalIntelligence
}
